import { TConvertKeys } from './common';

export enum EPaymentGateway {
  AZUL = 'azul',
  STRIPE = 'stripe',
}

export enum EPaymentStatus {
  PENDING = 'pending',
  SETTLED = 'settled',
}

export interface IPaymentDetailsData {
  id: string;
  appointment_id: string;
  status: {
    at: string;
    action: EPaymentStatus;
  }[];
  meta: {
    amount: number;
    currency: string;
  };
}

export type TPaymentDetailsDataCamel = TConvertKeys<IPaymentDetailsData>;

export enum EPaymentResults {
  APPROVED = 'approved',
  CANCELED = 'canceled',
  DECLINED = 'declined',
}

export interface IPaymentCheckoutSession {
  status: string;
  gateway_url: string;
  gateway_request_method: string;
  gateway_request_params: Record<string, string>;
}

export type TCheckoutSessionPayload = {
  status?: string;
  gateway_response_params?: Record<string, string>;
};
